const digest = 'af85ccc98aaba7a80b0e96acb61b940562e3147f4011f853d7e83447cd99b7c8';
const css = `.containerAncestor .container{max-width:1240px!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };